import { render, staticRenderFns } from "./sample.vue?vue&type=template&id=48d537aa&scoped=true&"
import script from "./sample.vue?vue&type=script&lang=js&"
export * from "./sample.vue?vue&type=script&lang=js&"
import style0 from "./sample.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./sample.vue?vue&type=style&index=1&id=48d537aa&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d537aa",
  null
  
)

export default component.exports